var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-menu sub-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'admin-users', params: {} }}},[_vm._v("Users")])],1),(_vm.user.type == 6)?_c('li',[_c('router-link',{attrs:{"to":{ name: 'admin-manage-user', params: {} }}},[_vm._v("Add User")])],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }